module.exports = __webpack_public_path__ + "assets/AirbnbCereal-Medium.d9fb3054e00c65841121da81c48e4fb1.ttf";